<template>
<div>
  <el-tooltip 
    v-model="tooltipVisible"
    :manual="true"
    :placement="placement"
    >
    <div slot="content" class="max-h-500p overflow-auto" :class="isLower1024 ? 'max-w-[18rem]' : ''"
      @mouseenter="tooltipVisible = true"
      @mouseleave="tooltipVisible = false">
      <span v-if="formatContent" v-safe-html="content"></span>
      <span v-else>{{ content }}</span>
    </div>
    <span class="tooltip-icon__icon-wrap"
      @keydown.esc="tooltipVisible = false"
      @mouseenter="tooltipVisible = true"
      @mouseleave="tooltipVisible = false"
      @focus="tooltipVisible = true"
      @blur="tooltipVisible = false">
      <base-icon 
        :size="size" 
        :name="finalIcon" 
        :custom="finalClass" 
        class="cbutton--prim-phantom bg-primary-50 dark:bg-darkblue text-primary hover:text-primary-800 dark:hover:text-white hover:bg-primary-100 dark:hover:bg-primary-500 rounded-full" 
        />
    </span>
  </el-tooltip>
</div>
</template>

<script>
const PLACEMENTS = ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']

export default {
  name: 'tooltip-icon',
  props: {
    content: {
      type: String,
      default: 'info'
    },
    placement: {
      type: String,
      default: 'right',
      validator: value => PLACEMENTS.includes(value)
    },
    size: {
      type: String,
      default: 'md'
    },
    formatContent: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'info'
    },
    icon: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
  },
  data: function () {
    return {
      tooltipVisible: false,
    }
  },
  computed: {
    isLower1024 () {
      return this.$store.getters['app/getIsLower1024']
    },
    finalClass: function () {
      return `${this.colorClass} ${this.customClass}`
    },
    finalIcon: function () {
      return this.icon || this.type
    },
    colorClass: function () {
      switch (this.type) {
        case 'success':
        case 'warning':
        case 'error':
        case 'none':
          return `base-icon-${this.type} hover:base-icon-${this.type} dark:base-icon-${this.type} dark:hover:base-icon-${this.type}`
      
        case 'info':
        default:
          return 'text-primary hover:text-primary-800 dark:hover:text-white hover:bg-primary-100 dark:hover:bg-primary-500'
      }
    }
  }
}
</script>
